import React, { useCallback, useEffect, useState } from 'react';
import { apiErrorMessage } from '../../utils/apiError';
import mcpServiceService from '../../services/mcpServiceService';
import SenderDomainCard from './SenderDomainCard';
import './McpServicePage.css';

// A HOTEL'S GUEST EMAIL SENDER, on Hotel › Products › MCP: the hotel's own sending domain, which overrides the chain's
// (Chain Settings › MCP). Without one verified, the hotel sends from the chain's domain, else hconnect's — the card
// says which, from the server's `effective` answer. The server decides who may change it (a hotel admin).

export default function McpHotelSender({ hotelId }) {
  const [data, setData] = useState(null);
  const [error, setError] = useState(null);
  const [busy, setBusy] = useState(null);

  const load = useCallback(async () => {
    if (!hotelId) return;
    setError(null);
    try { setData(await mcpServiceService.getHotelSender(hotelId)); } catch (e) { setError(apiErrorMessage(e)); }
  }, [hotelId]);
  useEffect(() => { setData(null); load(); }, [load]);

  const run = async (what, fn) => {
    setBusy(what);
    setError(null);
    try { setData(await fn()); } catch (e) { setError(apiErrorMessage(e)); } finally { setBusy(null); }
  };

  const chain = data && data.chainSenderDomain;
  const fallback = chain && chain.status === 'VERIFIED'
    ? { label: 'the chain’s domain', address: chain.address }
    : { label: 'hconnect’s address', address: null };

  return (
    <div className="mcps-page mcps-embedded">
      {error && <div className="os-msg os-msg-error">{error}</div>}
      {data && (
        <SenderDomainCard domain={data.senderDomain} fallback={fallback} canEdit={data.canEdit} busy={busy} run={run} ownerLabel="hotel"
                          onStart={(d) => mcpServiceService.startHotelSenderDomain(hotelId, d)}
                          onCheck={() => mcpServiceService.checkHotelSenderDomain(hotelId)}
                          onRemove={() => mcpServiceService.removeHotelSenderDomain(hotelId)} />
      )}
      {!data && !error && <p>Loading…</p>}
    </div>
  );
}
